module.exports = __webpack_public_path__ + "static/img/Cameron-Devlin.095e25f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cameron-Devlin.jpg
// module id = wqSf
// module chunks = 0